import { useApiMutation, useApiQuery } from "../services/react-query";

export const useGetSummary = (eventId, params) =>
  useApiQuery({
    queryOptions: {
      queryKey: ["insights", "summary", eventId, params],
      enabled: !!eventId,
    },
    fetchOptions: {
      url: `/events/${eventId}/insights/summary`,
      method: "GET",
      params,
    },
  });

const buildGet = (path) => (eventId, params) =>
  useApiQuery({
    queryOptions: {
      queryKey: ["insights", path, eventId, params],
      enabled: !!eventId,
    },
    fetchOptions: {
      url: `/events/${eventId}/insights/${path}`,
      method: "GET",
      params,
    },
  });

export const useGetAttendance = buildGet("attendance");
export const useGetOnSite = buildGet("on-site");
export const useGetAppAdoption = buildGet("app-adoption");
export const useGetContent = buildGet("content");
export const useGetVisibility = buildGet("visibility");
export const useGetSessionVisibility = buildGet("session-visibility");
export const useGetPages = buildGet("pages");
export const useGetRegistrations = buildGet("registrations");
export const useGetPolls = buildGet("polls");
export const useGetSurveys = buildGet("surveys");
export const useGetTags = buildGet("tags");
export const useGetGiveaways = buildGet("giveaways");
export const useGetNotifications = buildGet("notifications");
export const useGetEngagementSegmentation = buildGet("engagement-segmentation");

export const useGetInsightsAnalysis = (eventId) =>
  useApiQuery({
    queryOptions: {
      queryKey: ["insights", "analysis", eventId],
      enabled: !!eventId,
    },
    fetchOptions: {
      url: `/events/${eventId}/insights/analysis`,
      method: "GET",
    },
  });

export const usePatchInsightsAnalysis = (eventId) =>
  useApiMutation({
    mutationOptions: { mutationKey: "usePatchInsightsAnalysis" },
    fetchOptions: {
      url: `/events/${eventId}/insights/analysis`,
      method: "PATCH",
    },
    invalidateQueryKeys: [["insights", "analysis", eventId]],
    successMessage: { title: "Analysis updated", color: "green" },
  });

export const useGetAppUsage = (eventId, params) =>
  useApiQuery({
    queryOptions: {
      queryKey: ["insights", "app-usage", eventId, params],
      enabled: !!eventId,
    },
    fetchOptions: {
      url: `/events/${eventId}/insights/app-usage`,
      method: "GET",
      params,
    },
  });

export const useGetAppUsageWeights = (eventId) =>
  useApiQuery({
    queryOptions: {
      queryKey: ["insights", "app-usage", "weights", eventId],
      enabled: !!eventId,
    },
    fetchOptions: {
      url: `/events/${eventId}/insights/app-usage/weights`,
      method: "GET",
    },
  });

export const useUpdateAppUsageWeights = (eventId) =>
  useApiMutation({
    mutationOptions: { mutationKey: "useUpdateAppUsageWeights" },
    fetchOptions: {
      url: `/events/${eventId}/insights/app-usage/weights`,
      method: "PUT",
    },
    invalidateQueryKeys: [
      ["insights", "app-usage", eventId],
      ["insights", "app-usage", "weights", eventId],
    ],
    successMessage: {
      title: "App feature usage weights updated",
      color: "green",
    },
  });
